import {
  yt_polo_front,
  yt_polo_right,
  yt_polo_left,
  yt_polo_back,
  apron_black,
  apron_cropped,
  waist_apron,
  yt_polo_cap,
} from "../images";

export const POLO_SHIRT = {
  product_id: "750",
  product_category: "polo_shirt",
  embroidery: "1",
  print: "1",
  main_shirt_url: yt_polo_front,
  shirt_areas: [
    "chest_left",
    "chest_right",
    "sleeve_left",
    "sleeve_right",
    "back",
  ],

  position_image: {
    front: yt_polo_front,
    left: yt_polo_left,
    right: yt_polo_right,
    back: yt_polo_back,
  },

  chest_left: {
    url: yt_polo_front,

    box_dimension: {
      height: 100,
      width: 100,
      align: "align-items-center",
    },

    logo_max_width: 100,
    logo_min_width: 40,

    logo_position: {
      top: "17%",
      left: "47%",
    },
    transformOrigin: "74% 10%",
    shirt_scale: 3,
    logo_scale: 0.45,
  },
  chest_right: {
    url: yt_polo_front,

    box_dimension: {
      height: 100,
      width: 100,
      align: "align-items-center",
    },

    logo_max_width: 100,
    logo_min_width: 40,

    logo_position: {
      top: "17%",
      left: "26%",
    },
    transformOrigin: "20% 10%",
    shirt_scale: 3,
    logo_scale: 0.45,
  },

  sleeve_left: {
    url: yt_polo_left,

    box_dimension: {
      height: 70,
      width: 70,
      align: "align-items-end",
    },

    logo_max_width: 70,
    logo_min_width: 50,

    logo_position: {
      top: "21%",
      left: "44.5%",
    },
    transformOrigin: "48% 10%",
    shirt_scale: 3.5,
    logo_scale: 0.45,
  },

  sleeve_right: {
    url: yt_polo_right,

    box_dimension: {
      height: 70,
      width: 70,
      align: "align-items-end",
    },

    logo_max_width: 70,
    logo_min_width: 50,

    logo_position: {
      top: "21%",
      left: "38%",
    },
    transformOrigin: "45% 10%",
    shirt_scale: 3.5,
    logo_scale: 0.45,
  },

  back: {
    url: yt_polo_back,
    box_dimension: {
      height: 200,
      width: 200,
      align: "align-items-start",
    },

    logo_max_width: 200,
    logo_min_width: 90,

    logo_max_height: 145,
    logo_min_height: 45,

    logo_position: {
      top: "4%",
      left: "24.5%",
    },
    transformOrigin: "46.5% 8%",
    shirt_scale: 2.5,
    logo_scale: 0.45,
  },
};

// /---------------------->

export const FULL_APRON = {
  product_category: "apron",
  embroidery: "1",
  print: "1",
  main_shirt_url: apron_black,
  shirt_areas: ["chest_center"],
  position_image: {
    front: apron_black,
  },

  chest_center: {
    url: apron_black,

    box_dimension: {
      height: "200",
      width: "200",
      align: "align-items-start",
    },

    logo_max_width: 290,
    logo_min_width: 90,

    logo_max_height: 145,
    logo_min_height: 45,

    logo_position: {
      top: "17%",
      right: "15%",
    },
    transformOrigin: "49% 33%",
    shirt_scale: 4,
    logo_scale: 0.28,
  },
};

// waist apron

export const WAIST_APRON = {
  product_id: "750",
  product_category: "apron",
  embroidery: "1",
  print: "1",
  main_shirt_url: waist_apron,
  shirt_areas: ["chest_left"],
  position_image: {
    front: waist_apron,
  },

  chest_left: {
    url: waist_apron,

    box_dimension: {
      height: "200",
      width: "200",
      align: "align-items-center",
    },

    logo_max_width: 290,
    logo_min_width: 90,

    logo_max_height: 145,
    logo_min_height: 45,

    logo_position: {
      top: "15%",
      right: "-22%",
    },
    transformOrigin: "75.5% 33%",
    shirt_scale: 3,
    logo_scale: 0.36,
  },
};

export const CAP = {
  product_id: "750",
  product_category: "cap",
  embroidery: "1",
  print: "1",
  main_shirt_url: yt_polo_cap,
  shirt_areas: ["cap_center"],
  position_image: {
    front: yt_polo_cap,
  },

  cap_center: {
    url: waist_apron,

    box_dimension: {
      height: "200",
      width: "200",
      align: "align-items-center",
    },

    logo_max_width: 290,
    logo_min_width: 90,

    logo_max_height: 145,
    logo_min_height: 45,

    logo_position: {
      top: "15%",
      right: "-22%",
    },
    transformOrigin: "75.5% 33%",
    shirt_scale: 3,
    logo_scale: 0.36,
  },
};
